// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__pzS3S","content":"Consent_content__2U5GP","footer":"Consent_footer__3wx1y"};